import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
import IntlMessages from "Util/IntlMessages";
import { Row, Card, Button, CardTitle, CardBody, Collapse, Form, Progress, Input, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import { Colxx } from "Components/CustomBootstrap";
import "react-circular-progressbar/dist/styles.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import API from "../../api/index";
import TextareaAutosize from "react-textarea-autosize";
import StateButton from "Components/StateButton";

import { NotificationManager } from "Components/ReactNotifications";
const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
class tasks extends Component {
	constructor(props) {
		super(props);

		this.state = {
			autoUpdate: false,
			isAutoUpdating: false,
			newBatchModalOpen: false,
			newBatchSaveClicked: false,
			newBatch: {
				Title: "",
				Audience: "SELECT",
				Message: "",
				OperatorDescription: "",
			},
			newBatchTemplate: {
				Title: "",
				Audience: "SELECT",
				Message: "",
				OperatorDescription: "",
			},
			batches: [],
			tab: "NOT_STARTED",
			isLoading: true,
		};

		this.tabChanged = this.tabChanged.bind(this);
		this.loadData = this.loadData.bind(this);
		this.autoLoadData = this.autoLoadData.bind(this);

		this.newBatchModalToggle = this.newBatchModalToggle.bind(this);
		this.saveNewBatch = this.saveNewBatch.bind(this);
		this.canSaveNewBatch = this.canSaveNewBatch.bind(this);
		this.loadData();
	}
	componentDidMount() {
		setInterval(() => {
			if (this.state.autoUpdate && !this.state.isAutoUpdating) {
				this.setState({ isAutoUpdating: true }, () => {
					this.autoLoadData();
				});
			}
		}, 1000);

		if (this.props.location.state != undefined && this.props.location.state.tabDefaultIndex == 1) {
			this.setState(
				{
					autoUpdate: true,
					tab: "NOT_FINISHED",
					isLoading: true,
				},
				function () {
					this.loadData();
				}
			);
		}
	}
	saveNewBatch() {
		return new Promise((success, fail, $this) => {
			this.setState({ newBatchSaveClicked: true });

			API.sms.batch
				.add({
					Audience: this.state.newBatch.Audience,
					Message: this.state.newBatch.Message,
					Title: this.state.newBatch.Title,
					OperatorDescription: this.state.newBatch.OperatorDescription,
				})
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت ");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت دسته", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								newBatchSaveClicked: false,
							});
						}
					} else {
						success("دسته ثبت شد");
						setTimeout(() => {
							this.setState(
								{
									newBatchSaveClicked: false,
									newBatchModalOpen: false,
									newBatch: this.state.newBatchTemplate,
								},
								() => {
									this.loadData();
								}
							);
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت دسته جدید");
				});
		});
	}
	canSaveNewBatch() {
		var canSave = true;
		if (this.state.newBatch.Message.length < 40) {
			canSave = false;
		}
		if (this.state.newBatch.Audience == "SELECT") {
			canSave = false;
		}
		if (this.state.newBatch.Title.length < 10) {
			canSave = false;
		}
		return canSave;
	}
	newBatchModalToggle() {
		this.setState({
			newBatchModalOpen: !this.state.newBatchModalOpen,
		});
	}
	autoLoadData() {
		if (this.state.tab == "NOT_FINISHED") {
			API.sms.batch
				.archive({ tab: this.state.tab })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
					if (this.state.isAutoUpdating) {
						this.setState({
							batches: Array.isArray(data.batches) ? data.batches : [],
							isAutoUpdating: false,
						});
					}
				})
				.catch((error) => {});
		} else {
			// this.setState(
			// 	{
			// 		isAutoUpdating: false,
			// 	},
			// 	() => {
			// 		this.loadData();
			// 	}
			// );
		}
	}
	loadData(key) {
		API.sms.batch
			.archive({ tab: this.state.tab })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					batches: Array.isArray(data.batches) ? data.batches : [],
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => {});
	}
	tabChanged(index) {
		var tabs = [];
		tabs[0] = "NOT_STARTED";
		tabs[1] = "NOT_FINISHED";
		tabs[2] = "FINISHED";

		this.setState(
			{
				isAutoUpdating: false,
				autoUpdate: index === 1,
				tab: tabs[index],
				isLoading: true,
			},
			function () {
				this.loadData();
			}
		);
	}

	render() {
		return false ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row>
					<Colxx xl="12">
						<Tabs defaultIndex={this.props.location.state == undefined ? 0 : this.props.location.state.tabDefaultIndex} onSelect={(index) => this.tabChanged(index)}>
							<TabList>
								<Tab default={true}>
									<div className={"simple-icon-list headingicon"} />
									شروع نشده
								</Tab>
								<Tab>
									<div className={"iconsminds-loading headingicon"} />
									در حال ارسال
								</Tab>
								<Tab>
									<div className={"iconsminds-data-center headingicon"} />
									آرشیو
								</Tab>
							</TabList>

							<TabPanel>
								<Card>
									<CardBody>
										<CardTitle>
											<div className={"simple-icon-list headingicon"} />
											دسته‌های خام
											<Button
												color="primary"
												style={{ float: "left" }}
												className={"default"}
												onClick={() => {
													this.setState({ newBatchModalOpen: true });
												}}
											>
												دسته جدید
											</Button>
											<Modal isOpen={this.state.newBatchModalOpen} toggle={this.newBatchModalToggle}>
												<ModalHeader toggle={this.newBatchModalToggle}>ایجاد دسته جدید برای ارسال پیامک دسته‌ای </ModalHeader>
												<ModalBody>
													<table>
														<tbody>
															<tr>
																<th style={{ paddingLeft: "10px" }}>نام:</th>
																<td>
																	<Input
																		disabled={this.state.newBatchSaveClicked}
																		type="text"
																		style={{ width: "100%", borderRadius: "2px", border: "1px solid lightgray", paddingRight: "10px", borderColor: this.state.newBatch.Title.length > 10 ? "lightgray" : "orange" }}
																		onChange={(e) => {
																			var tmpObj = { ...this.state.newBatch };
																			tmpObj.Title = e.target.value;
																			this.setState({ newBatch: tmpObj });
																		}}
																		placeholder="مثلا: تبریک سال نو ۱۴۰۲ به مشتریان"
																	/>
																</td>
															</tr>
															<tr>
																<th style={{ paddingLeft: "10px" }}>مخاطب:</th>
																<td>
																	<Input
																		disabled={this.state.newBatchSaveClicked}
																		type="select"
																		onChange={(e) => {
																			var tmpObj = { ...this.state.newBatch };
																			tmpObj.Audience = e.target.value;
																			this.setState({ newBatch: tmpObj });
																		}}
																		value={this.state.newBatch.Audience}
																		style={{ borderColor: this.state.newBatch.Audience != "SELECT" ? "lightgray" : "orange" }}
																	>
																		<option value="SELECT">انتخاب کنید</option>
																		<option value="CUSTOMER">مشتری</option>
																		<option value="LEAD">سرنخ</option>
																	</Input>
																</td>
															</tr>
															<tr>
																<th style={{ paddingLeft: "10px" }}>توضیحات:</th>
																<td>
																	<textarea
																		disabled={this.state.newBatchSaveClicked}
																		rows="2"
																		style={{ width: "100%", borderRadius: "2px", border: "1px solid lightgray", padding: "10px" }}
																		onChange={(e) => {
																			var tmpObj = { ...this.state.newBatch };
																			tmpObj.OperatorDescription = e.target.value;
																			this.setState({ newBatch: tmpObj });
																		}}
																		placeholder="توضیحات مخفی فقط برای یادآوری  و مراجعات بعدی"
																	/>
																</td>
															</tr>
															<tr>
																<th style={{ paddingLeft: "10px" }}>پیام:</th>
																<td>
																	<TextareaAutosize
																		disabled={this.state.newBatchSaveClicked}
																		spellCheck={false}
																		style={{
																			width: "350px",
																			padding: "10px",
																			borderRadius: "10px",
																			background: "#e5e5ea",
																			borderBottomLeftRadius: "0",
																			lineHeight: "20px",
																			borderColor: this.state.newBatch.Message.length > 40 ? "lightgray" : "orange",
																		}}
																		onChange={(event) => {
																			var tmpObj = { ...this.state.newBatch };
																			tmpObj.Message = event.target.value.replace(/\r/g, "");
																			this.setState({ newBatch: tmpObj });
																			// console.log(Diff.diffChars(this.state.initialMessage,event.target.value));
																		}}
																		defaultValue={this.state.newBatch.Message}
																	/>
																</td>
															</tr>
															<tr>
																<th style={{ paddingLeft: "10px" }}>طول پیام:</th>
																<td>
																	{this.state.newBatch.Message.length} حرف معادل {Math.ceil(this.state.newBatch.Message.length / 60)} پیامک ۶۰ حرفی
																</td>
															</tr>
														</tbody>
													</table>
												</ModalBody>
												<ModalFooter>
													<StateButton disabled={!this.canSaveNewBatch()} id="newBatchSaveButton" color="primary" className="mb-3 default" onClick={() => this.saveNewBatch()}>
														ثبت
													</StateButton>
												</ModalFooter>
											</Modal>
										</CardTitle>
										{this.state.isLoading ? <div className="loading loading-inline"></div> : this.state.batches.map((row) => <BatchItem masterReload={this.loadData} key={row.BatchID} data={row} />)}
									</CardBody>
								</Card>
							</TabPanel>
							<TabPanel>
								<Card>
									<CardBody>
										<CardTitle>
											<div className={"iconsminds-loading headingicon"} />
											پیامک‌های دسته‌ای در حال ارسال
										</CardTitle>
										{this.state.isLoading ? <div className="loading loading-inline"></div> : this.state.batches.map((row) => <BatchItem key={row.BatchID} data={row} />)}
									</CardBody>
								</Card>
							</TabPanel>
							<TabPanel>
								<Card>
									<CardBody>
										<CardTitle>
											<div className={"iconsminds-data-center headingicon"} />
											آرشیو پیامک‌های دسته‌ای ارسال شده (۱۰ دسته آخر)
											<Button
												color="secondary"
												style={{ float: "left", color: "#60707c" }}
												className={"default mb-2"}
												onClick={() => {
													window.open("https://smp.akschap.com/batches");
												}}
											>
												مشاهده همه
											</Button>
											
										</CardTitle>
										{this.state.isLoading ? <div className="loading loading-inline"></div> : this.state.batches.map((row) => <BatchItem key={row.BatchID} data={row} />)}
									</CardBody>
								</Card>
							</TabPanel>
						</Tabs>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class BatchItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sendMobile: "",
			sendMessage: "",
			smsModalOpened: false,
			sms_isSending: false,
			editBatchModalOpen: false,
			editBatchSaveClicked: false,
			editBatch: {
				BatchID: this.props.data.BatchID,
				Title: this.props.data.Name,
				Audience: this.props.data.Audience,
				Message: this.props.data.Message,
				OperatorDescription: this.props.data.OperatorDescription,
			},
			toggleOpen: false,
		};

		this.toggleOpen = this.toggleOpen.bind(this);

		this.editBatchModalToggle = this.editBatchModalToggle.bind(this);
		this.saveEditBatch = this.saveEditBatch.bind(this);
		this.canSaveEditBatch = this.canSaveEditBatch.bind(this);
		this.deleteBatch = this.deleteBatch.bind(this);
		this.smsSend = this.smsSend.bind(this);
		this.smsModalToggle = this.smsModalToggle.bind(this);
	}
	smsSend() {
		return new Promise((success, fail, $this) => {
			this.setState({ sms_isSending: true });
			API.sms.batch
				.sendTest({ BatchID: this.state.editBatch.BatchID })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ارسال پیامک تست ");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ارسال پیامک تست", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
						}
						this.setState({
							sms_isSending: false,
						});
					} else {
						success("پیامک تست ارسال شد");
						setTimeout(() => {
							this.setState({
								sendMobile: data.mobile,
								sendMessage: data.message,
								sms_isSending: false,
								smsModalOpen: true,
							});
						}, 1000);
					}
				})
				.catch((error) => {
					setTimeout(
						function (err) {
							NotificationManager.error(err, "مشکل در ارسال پیامک به سرور", 8000, null, null, "filled");
						},
						700,
						error.message
					);
					fail("خطا در ارسال پیامک تست ");
					this.setState({
						sms_isSending: false,
					});
				});
		});
	}
	smsModalToggle() {
		this.setState({
			smsModalOpen: !this.state.smsModalOpen,
		});
	}
	deleteBatch() {
		if (confirm("آیا حذف این دسته را تایید می کنید؟")) {
			return new Promise((success, fail, $this) => {
				this.setState({ editBatchSaveClicked: true });

				API.sms.batch
					.edit({
						BatchID: this.state.editBatch.BatchID,
						Delete: true,
					})
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

						if (data.ERRORS !== undefined) {
							fail("خطا در حذف ");
							for (var i = 0; i < data.ERRORS.length; i++) {
								setTimeout(
									function (err) {
										NotificationManager.error(err, "خطا در حذف دسته", 8000, null, null, "filled");
									},
									(i + 1) * 700,
									data.ERRORS[i]
								);
								this.setState({
									editBatchSaveClicked: false,
								});
							}
						} else {
							success("دسته حذف شد");
							setTimeout(() => {
								this.props.masterReload();
							}, 1000);
						}
					})
					.catch((error) => {
						fail("خطا در ثبت دسته جدید");
					});
			});
		}
	}
	saveEditBatch() {
		return new Promise((success, fail, $this) => {
			this.setState({ editBatchSaveClicked: true });

			API.sms.batch
				.edit({
					BatchID: this.state.editBatch.BatchID,
					Audience: this.state.editBatch.Audience,
					Message: this.state.editBatch.Message,
					Title: this.state.editBatch.Title,
					OperatorDescription: this.state.editBatch.OperatorDescription,
				})
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت ");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت دسته", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								editBatchSaveClicked: false,
							});
						}
					} else {
						success("دسته ثبت شد");
						setTimeout(() => {
							this.props.data.Name = this.state.editBatch.Title;
							this.props.data.Message = this.state.editBatch.Message;
							this.props.data.Audience = this.state.editBatch.Audience;
							this.props.data.OperatorDescription = this.state.editBatch.OperatorDescription;

							this.setState({
								editBatchSaveClicked: false,
								editBatchModalOpen: false,
							});
						}, 1000);
					}
				})
				.catch((error) => {
					this.setState({
						editBatchSaveClicked: false,
					});
					fail("خطا در ثبت دسته جدید");
				});
		});
	}
	canSaveEditBatch() {
		var canSave = true;
		if (this.state.editBatch.Message.length < 40) {
			canSave = false;
		}
		if (this.state.editBatch.Audience == "SELECT") {
			canSave = false;
		}
		if (this.state.editBatch.Title.length < 10) {
			canSave = false;
		}
		return canSave;
	}
	editBatchModalToggle() {
		this.setState({
			editBatchModalOpen: !this.state.editBatchModalOpen,
		});
	}

	toggleOpen() {
		const prevState = this.state.toggleOpen;
		this.setState({
			toggleOpen: !prevState,
		});
	}

	render() {
		const {
			data: { Name, BatchID, OperatorDescription, Audience, SystemDescription, Message, Count, Total, IsStarted, IsFinished },
		} = this.props;

		return (
			<div className="border productPanel">
				<Button block color="link" className="text-right" onClick={() => this.toggleOpen()} aria-expanded={this.state.toggleOpen} style={{ background: this.state.toggleOpen ? "#ecfdff" : "#fff" }}>
					<table style={{ width: "50%", float: "right" }}>
						<tbody>
							<tr>
								<th style={{ width: "60%", color: this.state.toggleOpen ? "#4fcdc4" : "black" }}>
									<i className="iconsminds-box-with-folders" style={{ marginLeft: "5px", fontSize: "14px" }}></i> {Name}
								</th>
								<td style={{ width: "20%", color: "gray" }}>{Audience == "CUSTOMER" ? "مشتری" : "سرنخ"}</td>
								<td style={{ width: "20%" }}>{IsStarted ? numberWithCommas(Count) + "/" + numberWithCommas(Total) : ""}</td>
							</tr>
						</tbody>
					</table>
					<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px", float: "left" }}></i>
					{IsStarted ? (
						<Progress striped style={{ width: "45%", display: "inline-block", float: "left" }} color="primary" value={Math.min(100, (Count / Total) * 100)}>
							{Math.round(Math.min(100, (Count / Total) * 100) * 100) / 100}
							{"%"}
						</Progress>
					) : (
						<div />
					)}
				</Button>
				<Collapse isOpen={this.state.toggleOpen} style={{ background: "#ecfdff" }}>
					<div className="p-4">
						<Row className="mb-4">
							<Colxx xxs="12">
								<Colxx sm={12}>
									<table>
										<tbody>
											<tr>
												<th style={{ verticalAlign: "top", padding: "10px" }}>توضحات اپراتور:</th>
												<td
													style={{ padding: "10px", background: "#ffffff", borderRadius: "5px" }}
													dangerouslySetInnerHTML={{
														__html: OperatorDescription == null ? "" : OperatorDescription.replaceAll("\n", "<br/>"),
													}}
												></td>
											</tr>
											{IsStarted ? (
												<tr>
													<th style={{ padding: "10px" }}>توضحات سیستم:</th>
													<td style={{ padding: "10px" }}>{SystemDescription}</td>
												</tr>
											) : (
												false
											)}
											<tr style={{ verticalAlign: "top" }}>
												<th style={{ padding: "10px" }}>پیام:</th>
												<td style={{ padding: "10px" }}>
													<div
														style={{ background: "#e5e5ea", width: "700px", padding: "10px", borderRadius: "10px", float: "Left", borderBottomLeftRadius: "" }}
														dangerouslySetInnerHTML={{
															__html: Message.replaceAll("\n", "<br/>"),
														}}
													></div>
												</td>
											</tr>
											{!IsStarted ? (
												<tr>
													<th>&nbsp;</th>
													<td style={{ padding: "10px" }}>
														<StateButton
															color="info"
															className={"toggle-statebutton sms-send-button"}
															onClick={() => this.smsSend()}
															id={"send" + this.state.editBatch.BatchID}
															disabled={this.state.sms_isSending || this.state.editBatchSaveClicked}
														>
															<i
																className="iconsminds-mail-send"
																style={{
																	fontSize: 24,
																	fontWeight: 800,
																	height: 16,
																	display: "inline-block",
																}}
															></i>
															&nbsp;
														</StateButton>
														<Button
															disabled={this.state.editBatchSaveClicked}
															color="gray"
															style={{ float: "left", marginRight: "5px" }}
															className={"default"}
															onClick={() => {
																this.setState({ editBatchModalOpen: true });
															}}
															id={"edit" + this.state.editBatch.BatchID}
														>
															ویرایش
														</Button>
														<StateButton
															disabled={this.state.editBatchSaveClicked}
															color="gray"
															className={"toggle-statebutton default"}
															onClick={() => {
																this.deleteBatch();
															}}
															id={"delete" + this.state.editBatch.BatchID}
														>
															<i
																className="simple-icon-trash"
																style={{
																	fontSize: 16,
																	fontWeight: 800,
																	height: 17,
																	display: "inline-block",
																}}
															></i>
														</StateButton>
														<Modal onOpened={this.smsModalOpened} isOpen={this.state.smsModalOpen} toggle={this.smsModalToggle}>
															<ModalHeader toggle={this.smsModalToggle}>پیامک تست ارسال شد</ModalHeader>
															<ModalBody>
																<table>
																	<tbody>
																		<tr>
																			<th>موبایل:</th>
																			<td>{this.state.sendMobile}</td>
																		</tr>

																		<tr>
																			<th>پیام:</th>
																			<td>
																				<div
																					style={{ background: "#e5e5ea", width: "400px", padding: "10px", borderRadius: "10px", float: "Left", borderBottomLeftRadius: "" }}
																					dangerouslySetInnerHTML={{
																						__html: this.state.sendMessage,
																					}}
																				></div>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</ModalBody>
														</Modal>
														<Modal isOpen={this.state.editBatchModalOpen} toggle={this.editBatchModalToggle}>
															<ModalHeader toggle={this.editBatchModalToggle}>ویرایش دسته {BatchID} برای ارسال پیامک دسته‌ای </ModalHeader>
															<ModalBody>
																<table>
																	<tbody>
																		<tr>
																			<th style={{ paddingLeft: "10px" }}>نام:</th>
																			<td>
																				<Input
																					disabled={this.state.editBatchSaveClicked}
																					type="text"
																					style={{
																						width: "100%",
																						borderRadius: "2px",
																						border: "1px solid lightgray",
																						paddingRight: "10px",
																						borderColor: this.state.editBatch.Title.length > 10 ? "lightgray" : "orange",
																					}}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.editBatch };
																						tmpObj.Title = e.target.value;
																						this.setState({ editBatch: tmpObj });
																					}}
																					value={this.state.editBatch.Title}
																					placeholder="مثلا: تبریک سال نو ۱۴۰۲ به مشتریان"
																				/>
																			</td>
																		</tr>
																		<tr>
																			<th style={{ paddingLeft: "10px" }}>مخاطب:</th>
																			<td>
																				<Input
																					disabled={this.state.editBatchSaveClicked}
																					type="select"
																					onChange={(e) => {
																						var tmpObj = { ...this.state.editBatch };
																						tmpObj.Audience = e.target.value;
																						this.setState({ editBatch: tmpObj });
																					}}
																					value={this.state.editBatch.Audience}
																					style={{ borderColor: this.state.editBatch.Audience != "SELECT" ? "lightgray" : "orange" }}
																				>
																					<option value="CUSTOMER">مشتری</option>
																					<option value="LEAD">سرنخ</option>
																				</Input>
																			</td>
																		</tr>
																		<tr>
																			<th style={{ paddingLeft: "10px" }}>توضیحات:</th>
																			<td>
																				<textarea
																					disabled={this.state.editBatchSaveClicked}
																					rows="2"
																					style={{ width: "100%", borderRadius: "2px", border: "1px solid lightgray", padding: "10px" }}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.editBatch };
																						tmpObj.OperatorDescription = e.target.value;
																						this.setState({ editBatch: tmpObj });
																					}}
																					placeholder="توضیحات مخفی فقط برای یادآوری  و مراجعات بعدی"
																					value={this.state.editBatch.OperatorDescription}
																				/>
																			</td>
																		</tr>
																		<tr>
																			<th style={{ paddingLeft: "10px" }}>پیام:</th>
																			<td>
																				<TextareaAutosize
																					disabled={this.state.editBatchSaveClicked}
																					spellCheck={false}
																					style={{
																						width: "350px",
																						padding: "10px",
																						borderRadius: "10px",
																						background: "#e5e5ea",
																						borderBottomLeftRadius: "0",
																						lineHeight: "20px",
																						borderColor: this.state.editBatch.Message.length > 40 ? "lightgray" : "orange",
																					}}
																					onChange={(event) => {
																						var tmpObj = { ...this.state.editBatch };
																						tmpObj.Message = event.target.value.replace(/\r/g, "");
																						this.setState({ editBatch: tmpObj });
																						// console.log(Diff.diffChars(this.state.initialMessage,event.target.value));
																					}}
																					defaultValue={this.state.editBatch.Message}
																				/>
																			</td>
																		</tr>
																		<tr>
																			<th style={{ paddingLeft: "10px" }}>طول پیام:</th>
																			<td>
																				{this.state.editBatch.Message.length} حرف معادل {Math.ceil(this.state.editBatch.Message.length / 60)} پیامک ۶۰ حرفی
																			</td>
																		</tr>
																	</tbody>
																</table>
															</ModalBody>
															<ModalFooter>
																<StateButton disabled={!this.canSaveEditBatch()} id={"editBatchSaveButton" + BatchID} color="primary" className="mb-3 default" onClick={() => this.saveEditBatch()}>
																	ثبت
																</StateButton>
															</ModalFooter>
														</Modal>
													</td>
												</tr>
											) : (
												<tr>
													<td colSpan={2} style={{ textAlign: "left",padding:"10px" }}>
														<Button
															onClick={() => {
																window.open("https://smp.akschap.com/dashboard-batch?batch=" + BatchID);
															}}
															disabled={false}
															id="toggleSMS"
															className="default mb-2"
															style={{  color: "#60707c" }}
															color="secondary"
														>
															گزارش دقیق
														</Button>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</Colxx>
							</Colxx>
						</Row>
					</div>
				</Collapse>
			</div>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(tasks));
